// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"6a1b58e0","66":"b5232369","332":"89caecb8","389":"8eba88c0","390":"b5232369","698":"fa20874b"}[chunkId] + ".chunk.css";
};